
import React, { ReactNode } from 'react';
import { motion } from 'framer-motion';

interface ProtectionCardProps {
  children: ReactNode;
  isLocked?: boolean;
}

const ProtectionCard = ({ children, isLocked }: ProtectionCardProps) => {
  return (
    <div className="cyber-card relative p-8">
      {!isLocked && (
        <>
          <div className="cyber-notch cyber-notch-tl"></div>
          <div className="cyber-notch cyber-notch-tr"></div>
          <div className="cyber-notch cyber-notch-bl"></div>
          <div className="cyber-notch cyber-notch-br"></div>
        </>
      )}
      {children}
    </div>
  );
};

export default ProtectionCard;
